/**
 * OTSDR UI Manager
 * Manages overlays (modals/drawers) to prevent superposition
 */
(function() {
  'use strict';

  // Global state
  window.OTSDR_UI = window.OTSDR_UI || {
    overlay: null, // 'upsell' | 'cart' | null
    stickyMuted: false,
    suppressSticky: false, // Prevents sticky cart flash before upsell drawer opens
    _nativeUpsellOpen: null,
    _nativeCartOpen: null,
    _nativeUpsellClose: null,
    _nativeCartClose: null
  };

  // Set current overlay
  function setOverlay(name) {
    window.OTSDR_UI.overlay = name;
    document.documentElement.toggleAttribute('data-otsdr-overlay', !!name);
    if (name) {
      document.documentElement.setAttribute('data-otsdr-overlay-name', name);
    } else {
      document.documentElement.removeAttribute('data-otsdr-overlay-name');
    }
  }

  // Mute/unmute sticky cart
  function muteSticky(mute) {
    window.OTSDR_UI.stickyMuted = mute;
    const sticky = document.getElementById('otsdr-sticky-minicart');
    if (sticky) {
      if (mute) {
        sticky.classList.add('is-muted');
      } else {
        sticky.classList.remove('is-muted');
      }
    }
  }

  // Open upsell drawer
  function openUpsell(size) {
    // Close cart drawer if open
    if (window.OTSDR_UI.overlay === 'cart') {
      if (window.OTSDR_UI._nativeCartClose) {
        window.OTSDR_UI._nativeCartClose();
      }
    }

    setOverlay('upsell');
    muteSticky(true);

    // Call SAVED native upsell open function directly (no recursion)
    if (window.OTSDR_UI._nativeUpsellOpen) {
      window.OTSDR_UI._nativeUpsellOpen(size);
    }
  }

  // Close upsell drawer
  function closeUpsell() {
    setOverlay(null);
    muteSticky(false);

    // Call native upsell close function
    if (window.OTSDR_UI._nativeUpsellClose) {
      window.OTSDR_UI._nativeUpsellClose();
    }
  }

  // Open cart drawer
  function openCart() {
    // Close upsell drawer if open
    if (window.OTSDR_UI.overlay === 'upsell') {
      closeUpsell();
      // Wait for upsell to close
      setTimeout(() => {
        proceedOpenCart();
      }, 260);
    } else {
      proceedOpenCart();
    }
  }

  function proceedOpenCart() {
    setOverlay('cart');
    muteSticky(false);

    // Call native cart open function
    if (window.OTSDR_UI._nativeCartOpen) {
      window.OTSDR_UI._nativeCartOpen();
    }
  }

  // Close cart drawer
  function closeCart() {
    setOverlay(null);
    muteSticky(false);

    // Call native cart close function
    if (window.OTSDR_UI._nativeCartClose) {
      window.OTSDR_UI._nativeCartClose();
    }
  }

  // Expose global functions
  window.OTSDR_openUpsell = openUpsell;
  window.OTSDR_closeUpsell = closeUpsell;
  window.OTSDR_openCart = openCart;
  window.OTSDR_closeCart = closeCart;

  // Save native functions and setup interception
  // Run immediately (not waiting for DOMContentLoaded) to catch early definitions
  function setupInterception() {
    // Save native upsell functions if they exist
    if (typeof window.openOtsdrUpsellDrawer === 'function' && !window.OTSDR_UI._nativeUpsellOpen) {
      window.OTSDR_UI._nativeUpsellOpen = window.openOtsdrUpsellDrawer;
      // Replace with managed version
      window.openOtsdrUpsellDrawer = function(size) {
        openUpsell(size);
      };
    }

    if (typeof window.closeOtsdrUpsellDrawer === 'function' && !window.OTSDR_UI._nativeUpsellClose) {
      window.OTSDR_UI._nativeUpsellClose = window.closeOtsdrUpsellDrawer;
      window.closeOtsdrUpsellDrawer = function() {
        closeUpsell();
      };
    }

    // Save native cart functions if they exist
    if (typeof window.openOtsdrCartDrawer === 'function' && !window.OTSDR_UI._nativeCartOpen) {
      window.OTSDR_UI._nativeCartOpen = window.openOtsdrCartDrawer;
      window.openOtsdrCartDrawer = function() {
        openCart();
      };
    }

    if (typeof window.closeOtsdrCartDrawer === 'function' && !window.OTSDR_UI._nativeCartClose) {
      window.OTSDR_UI._nativeCartClose = window.closeOtsdrCartDrawer;
      window.closeOtsdrCartDrawer = function() {
        closeCart();
      };
    }
  }

  // Try to setup immediately
  setupInterception();

  // Also setup on DOMContentLoaded in case sections load after
  document.addEventListener('DOMContentLoaded', setupInterception);

  // Failsafe: retry after a short delay for late-loading sections
  setTimeout(setupInterception, 100);
})();
